import { useState, useEffect } from "react";
import { debounceEvent } from 'shared/utils/debounce';

export const useScrollDown = () => {
    const [scrollDown, setScrollDown] = useState(false);
    const [isScrolling, setIsScrolling] = useState(false);
    const [prevPosition, setPrevPosition] = useState(false);

    const onScrollDownSet = (ev: any) => {
        const prev = window.scrollY;
        setTimeout(() => {
            const current = window.scrollY;
            if (current > prev) {
                setScrollDown(true);
                setPrevPosition(false);
                setIsScrolling(true);

            }  else if (current < prev) {
                setScrollDown(false);
                setPrevPosition(true);
                setIsScrolling(false);
            }
            // else if (current === prev && !prevPosition) {
                // setTimeout(() =>  {
                //     setScrollDown(false);
                //     setPrevPosition(true);
                //     setIsScrolling(false);
                // },500)
            // }
        }, 500)
    }

    useEffect(() => {
        window.addEventListener('scroll', onScrollDownSet)

        return () => {
            window.removeEventListener('scroll', onScrollDownSet);        
        }
    }, [])
    
    return [scrollDown, prevPosition, isScrolling]
}import { useState, useEffect } from "react";
import { debounceEvent } from 'shared/utils/debounce';

export const useScrollDown = () => {
    const [scrollDown, setScrollDown] = useState(false);
    const [isScrolling, setIsScrolling] = useState(false);
    const [prevPosition, setPrevPosition] = useState(false);

    const onScrollDownSet = (ev: any) => {
        const prev = window.scrollY;
        setTimeout(() => {
            const current = window.scrollY;
            if (current > prev) {
                setScrollDown(true);
                setPrevPosition(false);
                setIsScrolling(true);

            }  else if (current < prev) {
                setScrollDown(false);
                setPrevPosition(true);
                setIsScrolling(false);
            }
            // else if (current === prev && !prevPosition) {
                // setTimeout(() =>  {
                //     setScrollDown(false);
                //     setPrevPosition(true);
                //     setIsScrolling(false);
                // },500)
            // }
        }, 500)
    }

    useEffect(() => {
        window.addEventListener('scroll', onScrollDownSet)

        return () => {
            window.removeEventListener('scroll', onScrollDownSet);        
        }
    }, [])
    
    return [scrollDown, prevPosition, isScrolling]
}